import * as React from 'react';

interface Props {
  size?: number;
  title?: string;
}

export default function Loading({ size = 14, title }: Props) {
  // 泡の色（海っぽいグラデーション）
  const bubbleColors = [
    '#5EEAD4', // teal-300
    '#22D3EE', // cyan-400
    '#38BDF8', // sky-400
    '#818CF8', // indigo-400
    '#5EEAD4', // teal-300
  ];

  return (
    <div
      className="fixed w-full h-full bottom-0 z-10"
      style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}
    >
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-4 justify-center">
        {title && (
          <span className="text-white text-xl text-center drop-shadow-lg animate-pulse">
            {title}
          </span>
        )}

        {/* かわいい泡ローダー */}
        <div className="flex items-end gap-2">
          {bubbleColors.map((color, index) => (
            <div
              key={index}
              className="rounded-full shadow-lg"
              style={{
                width: size,
                height: size,
                backgroundColor: color,
                animation: `bubble-bounce 1.4s ease-in-out ${
                  index * 0.15
                }s infinite`,
                boxShadow: `0 0 ${size / 2}px ${color}40, inset 0 -${
                  size / 4
                }px ${size / 3}px rgba(255,255,255,0.3)`,
              }}
            />
          ))}
        </div>

        <style jsx>{`
          @keyframes bubble-bounce {
            0%,
            80%,
            100% {
              transform: translateY(0) scale(1);
            }
            40% {
              transform: translateY(-${size * 1.5}px) scale(1.1);
            }
          }

          @keyframes turtle-swim {
            0%,
            100% {
              transform: translateX(-8px) rotate(-5deg);
            }
            50% {
              transform: translateX(8px) rotate(5deg);
            }
          }
        `}</style>
      </div>
    </div>
  );
}
